<app-banner [title]="'Contrats'" [links]="links"></app-banner>

<div class="container">
	<div class="flex gap-4 mt-5 pb-12">
		<div class="min-w-[330px] sticky top-[150px] bg-white shadow rounded-lg p-4 h-[60vh] hidden lg:block">
			<h4 class="!text-[12px] font-medium text-gray-400">Détail Contrat</h4>

			<div class="space-y-3 mt-4">
				@for (menu of insuranceMenu; track menu.key) {
				<div class="flex items-center gap-3 cursor-pointer rounded p-3"
					[class.text-white]="selectedMenu.key === menu.key"
					[class.bg-primary]="selectedMenu.key === menu.key" (click)="selectedMenu = menu">
					<lucide-icon [img]="menu.icon" class="" [size]="24"></lucide-icon>
					<span class="text-sm font-medium">{{ menu.label }}</span>
				</div>
				}
			</div>
		</div>
		<div class="bg-white w-full p-4 shadow rounded-lg min-h-[60vh] relative overflow-hidden flex flex-col">
			<div class="flex items-center justify-between">
				<h5 class="!text-[12px] font-medium text-gray-400 uppercase">{{ selectedMenu.label }}</h5>
				<div class="flex items-center gap-2">
					@if (selectedMenu.key === 'messages') {
					<button class="bg-primary text-white px-4 py-2 rounded-md !text-[12px]"
						(click)="openNewMessage()">Nouveau
						message</button>
					}
					<button class="lg:hidden" (click)="toggleMenu()">
						<lucide-icon [img]="Menu" class="" [size]="21"></lucide-icon>
					</button>
				</div>
			</div>

			<div class="space-y-3 absolute top-0 right-0 shadow w-[300px] h-full bg-white p-4"
				[class.hidden]="!isMenuOpen">
				<button (click)="toggleMenu()">
					<lucide-icon [img]="CloseIcon" class="" [size]="21"></lucide-icon>
				</button>
				@for (menu of insuranceMenu; track menu.key) {
				<div class="flex items-center gap-3 cursor-pointer rounded p-3"
					[class.text-white]="selectedMenu.key === menu.key"
					[class.bg-primary]="selectedMenu.key === menu.key" (click)="selectedMenu = menu">
					<lucide-icon [img]="menu.icon" class="" [size]="24"></lucide-icon>
					<span class="text-sm font-medium">{{ menu.label }}</span>
				</div>
				}
			</div>
			<div class="mt-4 h-max pb-3 flex-grow">
				@switch (selectedMenu.key) {
				@case ('contract_dashboard') {
				<!-- Loading / Error states (optional, but follows your pattern) -->
				<div *ngIf="contractStatisticsLoading" class="text-sm text-gray-500">Chargement des statistiques...
				</div>
				<div *ngIf="contractStatisticsError" class="text-sm text-red-600">{{ contractStatisticsError }}</div>

				<ng-container
					*ngIf="!contractStatisticsLoading && !contractStatisticsError && contractStatistics as stats">
					<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-2">

						<!-- Nbr prestations financières -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 text-xl mr-4">
								💵</div>
							<div>
								<div class="text-sm text-gray-500">Nbr prestations financières</div>
								<div class="text-2xl font-semibold text-gray-900">{{ stats.totalPrestations }}</div>
							</div>
						</div>

						<!-- Total Dépenses -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-rose-100 text-rose-600 text-xl mr-4">
								💰</div>
							<div>
								<div class="text-sm text-gray-500">Total dépenses du patient</div>
								<div class="text-2xl font-semibold text-gray-900">{{ stats.totalExpenses | frNumber }}
								</div>
							</div>
						</div>

						<!-- Moyenne dépenses par mois -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-cyan-100 text-cyan-600 text-xl mr-4">
								📈</div>
							<div>
								<div class="text-sm text-gray-500">Moyenne dépenses du patient par mois</div>
								<div class="text-2xl font-semibold text-gray-900">{{ stats.averageMonthlyExpenses |
									frNumber }}</div>
							</div>
						</div>

						<!-- Coût Santé -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-slate-100 text-slate-600 text-xl mr-4">
								🩺</div>
							<div>
								<div class="text-sm text-gray-500">Coût santé</div>
								<div class="text-2xl font-semibold text-gray-900">{{ stats.totalExpensesBeforeCoverage |
									frNumber }}</div>
							</div>
						</div>

						<!-- Coût moyen par mois -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 text-indigo-600 text-xl mr-4">
								📊</div>
							<div>
								<div class="text-sm text-gray-500">Coût moyen par mois</div>
								<div class="text-2xl font-semibold text-gray-900">{{
									stats.averageGeneralMonthlyExpensesBeforeCoverage | frNumber }}</div>
							</div>
						</div>

						<!-- Montant à rembourser (ce contrat) -->
						<div class="flex items-center p-4 bg-white rounded-lg shadow-sm"
							title="Ce montant correspond aux frais avancés pour vous par votre couverture santé (IPM, assurance ou employeur) et que vous devez lui restituer.">
							<div
								class="flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 text-amber-600 text-xl mr-4">
								💳</div>
							<div>
								<div class="text-sm text-gray-500">Montant à rembourser à votre couverture santé</div>
								@if (amountToBeReimbursedLoading) {
								<div class="text-2xl font-semibold text-gray-400">Chargement...</div>
								} @else {
								<div class="text-2xl font-semibold text-gray-900">{{ (amountToBeReimbursed ?? 0) |
									frNumber }}</div>
								}
							</div>
						</div>
					</div>
				</ng-container>
				}
				@case ('beneficiaries') {
				<app-insurance-beneficiaries [beneficiaries]="beneficiaries" [loading]="beneficiariesLoading"
					[error]="beneficiariesError">
				</app-insurance-beneficiaries>
				}
				@case ('financial_documents') {
				<app-documents *ngIf="contractId" [beneficiaries]="documentsBeneficiaries" [showAddButton]="false"
					[contractId]="contractId">
				</app-documents>
				}
				@case ('messages') {
				<app-messages [beneficiaries]="documentsBeneficiaries" [contract]="contract"
					[contractId]="contractId || ''" [insurerExternalId]="contract?.insurer?.externalId">
				</app-messages>
				}
				@case ('prestations') {
				<app-medical-history [beneficiaries]="documentsBeneficiaries" [policeExternalId]="policeExternalId">
				</app-medical-history>
				}
				@case ('care_networks') {
				@if (contract?.organism?.externalId) {
				<app-care-networks [networks]="careNetworks" [organismExternalId]="contract?.organism?.externalId"
					[loading]="careNetworksLoading" [error]="careNetworksError">
				</app-care-networks>
				}
				}
				@default {
				<div>Sélectionnez une option du menu.</div>
				}
				}
			</div>
		</div>
	</div>
</div>